<template>
  <div class="sdk_list_container">
    <div class="sdk_list_box">
      <div class="h2">
        <span>第三方SDK目录</span>
      </div>
      <div class="h4">
        <span>华为推送 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：推送消息</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://developer.huawei.com/consumer/cn/service/hms/pushservice.html">https://developer.huawei.com/consumer/cn/service/hms/pushservice.html</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>小米推送 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：推送消息</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://dev.mi.com/console/appservice/push.html">https://dev.mi.com/console/appservice/push.html</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>极光推送 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：推送消息</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息、设备MAC地址、软件安装列表、获取粘贴板信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.jiguang.cn/push">https://www.jiguang.cn/push</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>极光认证 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：手机号码一键登录</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息、电话号码、设备MAC地址、软件安装列表、获取粘贴板信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.jiguang.cn/identify">https://www.jiguang.cn/identify</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>友盟 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：数据统计</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：获取IMSI 、获取Android_ID 、获取设备序列号 、获取SIM序列号、设备MAC地址、软件安装列表</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.umeng.com/analytics">https://www.umeng.com/analytics</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>百度地图 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：用户发表信息时显示所在位置</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息、地理位置信息、传感器信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://lbsyun.baidu.com/">https://lbsyun.baidu.com/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>七牛云对象存储 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：用户上传图片视频</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息、图片或视频文件</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.qiniu.com/products/kodo">https://www.qiniu.com/products/kodo</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>穿山甲SDK（com.bytedance.sdk）</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：广告</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：获取网络状态、访问Wi-Fi状态、位置信息、读写外置存储器、读取手机状态和身份</span>
          </p>
        </li>
        <li>
          <p>
            <span>SDK隐私政策链接：<a href="https://www.pangle.cn/privacy/partner">https://www.pangle.cn/privacy/partner</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>阿里云快速接口解析 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：解析接口数据渲染页面</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息、获取IMSI</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://github.com/alibaba/fastjson">https://github.com/alibaba/fastjson</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>阿里路由 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：解析接口数据渲染页面</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息、设备MAC地址、软件安装列表</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://github.com/alibaba/ARouter/tree/master">https://github.com/alibaba/ARouter/tree/master</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>腾讯TBS浏览服务</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：提高新闻页webview的用户浏览体验</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息、设备MAC地址、软件安装列表</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://x5.tencent.com/tbs/guide/sdkInit.html">https://x5.tencent.com/tbs/guide/sdkInit.html</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>腾讯bugly</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：统计应用的崩溃信息日志</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备识别信息、获取Android_ID</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://bugly.qq.com/v2/">https://bugly.qq.com/v2/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>微信 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>微博 SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.weibo.com/development/mobile">https://open.weibo.com/development/mobile</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>QQ SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：用户进行第三方账号登录以及分享内容到第三方平台</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集数据类型：设备信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.tencent.com/">https://open.tencent.com/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>讯飞SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：语音合成</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集信息范围：设备号（IMEI号）、设备码（IMSI码）、IP地址、Android ID（安卓唯一设备ID以提供能力授权服务）、中国移动UAID（仅限安卓设备）、OAID（仅限安卓设备）、UUID（仅限iOS设备）、mac地址（仅限Linux设备）</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://www.xfyun.cn/">https://www.xfyun.cn/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>岳鹰SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：实现数据监测、崩溃日志</span>
          </p>
        </li>
        <li>
          <p>
            <span>功能类型：登录/推送</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集信息范围：设备信息、崩溃日志</span>
          </p>
        </li>
        <li>
          <p>
            <span>第三方主体：广州市动景计算机科技有限公司</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://yueying.effirst.com/index">https://yueying.effirst.com/index</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>IJKPlaver</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：录播视频服务</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集信息范围：网络权限</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://github.com/bilibili/ijkplayer">https://github.com/bilibili/ijkplayer</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>支付宝SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>使用目的：支付</span>
          </p>
        </li>
        <li>
          <p>
            <span>收集信息范围：设备号、IP地址、设备软件信息、设备识别码、设备识别符、所在地区、网络使用习惯、设备相关应用信息以及其他与支付宝服务相关的日志信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>第三方主体：支付宝(中国)网络技术有限公司</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.alipay.com/">https://open.alipay.com/</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>OPPO推送SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>涉及的个人信息类型：设备标识符（如 IMEI、ICCID、IMSI、Android ID、GAID）、应用信息（如应用包名、版本号和运行状态）、网络信息（如 IP 或域名连接结果，当前网络类型）</span>
          </p>
        </li>
        <li>
          <p>
            <span>使用目的：推送消息</span>
          </p>
        </li>
        <li>
          <p>
            <span>使用场景：在 OPPO 手机终端推送消息时使用</span>
          </p>
        </li>
        <li>
          <p>
            <span>第三方主体：广东欢太科技有限公司</span>
          </p>
        </li>
        <li>
          <p>
            <span>数据处理方式：通过加密传输和处理的安全处理方式</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.oppomobile.com/new/introduction?page_name=oppopush">https://open.oppomobile.com/new/introduction?page_name=oppopush</a></span>
          </p>
        </li>
        <li>
          <p>
            <span>隐私政策：<a href="https://open.oppomobile.com/wiki/doc#id=10288">https://open.oppomobile.com/wiki/doc#id=10288</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>vivo推送SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>涉及的个人信息类型：设备信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>使用目的：推送消息</span>
          </p>
        </li>
        <li>
          <p>
            <span>使用场景：在 vivo 手机终端推送消息时使用</span>
          </p>
        </li>
        <li>
          <p>
            <span>第三方主体：广东天宸网络科技有限公司及将来受让运营 vivo 开放平台的公司</span>
          </p>
        </li>
        <li>
          <p>
            <span>数据处理方式：通过去标识化、加密传输及其他安全方式</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://dev.vivo.com.cn/promote/pushNews">https://dev.vivo.com.cn/promote/pushNews</a></span>
          </p>
        </li>
        <li>
          <p>
            <span>隐私政策：<a href="https://www.vivo.com.cn/about-vivo/privacy-policy">https://www.vivo.com.cn/about-vivo/privacy-policy</a></span>
          </p>
        </li>
      </ul>
      <div class="h4">
        <span>魅族推送SDK</span>
      </div>
      <ul>
        <li>
          <p>
            <span>涉及的个人信息类型：设备标识信息、位置信息、网络状态信息、运营商信息</span>
          </p>
        </li>
        <li>
          <p>
            <span>使用目的：推送消息</span>
          </p>
        </li>
        <li>
          <p>
            <span>使用场景：在魅族手机终端推送消息时使用</span>
          </p>
        </li>
        <li>
          <p>
            <span>第三方主体：珠海市魅族通讯设备有限公司</span>
          </p>
        </li>
        <li>
          <p>
            <span>数据处理方式：通过去标识化、加密传输及其他安全方式</span>
          </p>
        </li>
        <li>
          <p>
            <span>官网链接：<a href="https://open.flyme.cn/service?type=push">https://open.flyme.cn/service?type=push</a></span>
          </p>
        </li>
        <li>
          <p>
            <span>隐私政策：<a href="https://www.meizu.com/legal.html">https://www.meizu.com/legal.html</a></span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { loadStat } from "@/utils";
export default {
  name: "SDKList",
  data() {
    return {};
  },
  methods: {},
  created() {
    document.title = "第三方SDK目录";
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.sdk_list_container {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  color: #000;
  * {
    word-break: break-all;
    white-space: normal;
    line-height: 1.5em;
  }
  .sdk_list_box {
    .h2 {
      padding: 18px 0;
      font-size: 18px;
      font-weight: bolder;
      text-align: center;
    }
    .h4 {
      margin-top: 15px;
      font-size: 16px;
      font-weight: bolder;
    }
    ul {
      li {
        margin-left: 20px;
        list-style-type: disc;
        p {
          color: #000;
          font-size: 16px;
          font-family: "宋体";
          span {
            font-size: 16px;
            font-family: "宋体";
            a {
              text-decoration: underline;
              font-family: "宋体";
            }
          }
        }
      }
    }
  }
}
</style>